var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"vx-bundles"},[_c('h1',{staticClass:"mb-xs-4"},[_vm._v(_vm._s(_vm.bundlesData.title))]),_vm._v(" "),_c('div',{staticClass:"row bundles-wrapper"},_vm._l((_vm.bundlesData.ImageList),function(bundle,index){return _c('div',{staticClass:"bundles-image-wrapper mb-sm-4 mb-xs-3 col-xs-12 col-sm-6 col-md-4"},[_c('vx-image-tile',{attrs:{"imageTileData":bundle}})],1)}),0)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-316da7dd","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./src/components/common/vx-bundles/vx-bundles.html
// module id = null
// module chunks = 